import MediaNotAvailable from '@components/media_not_available';
import { Img } from '@xo-union/tk-component-picture';
import React from 'react';
import type { Raw } from 'types/vendor';
import { getVendorImage } from '../../../utils/transformNetworkData';
import Styles from './FiveVendorImageGrid.styles.scss';

interface FiveVendorImageGridProps {
	vendors: Raw[];
}

export const FiveVendorImageGrid: React.FC<FiveVendorImageGridProps> = ({
	vendors,
}) => {
	const vendorsWithImages = vendors
		.map((vendor) => ({
			vendor,
			image: getVendorImage(vendor),
		}))
		.filter((item) => item.image !== null)
		.slice(0, 5);

	if (vendorsWithImages.length === 0) {
		return (
			<div
				className={Styles.placeholderWrapper}
				data-testid="celebration-photo-grid-placeholder"
			>
				<MediaNotAvailable />
			</div>
		);
	}

	return (
		<div
			className={Styles.fiveVendorsLayout}
			data-testid="celebration-photo-grid-layout5"
		>
			<div
				className={Styles.topRowFive}
				data-testid="celebration-photo-grid-top-row"
			>
				{vendorsWithImages[0] && (
					<div
						className={Styles.topMainImageFive}
						data-testid="celebration-photo-grid-top-main-image"
					>
						<Img
							src={vendorsWithImages[0].image as string}
							alt={vendorsWithImages[0].vendor.name}
							className={Styles.image}
							smartCrop
							data-testid="celebration-photo-grid-image-0"
						/>
					</div>
				)}
				<div
					className={Styles.topSideImagesFive}
					data-testid="celebration-photo-grid-top-side-images"
				>
					{vendorsWithImages[1] && (
						<div
							className={Styles.topSideImageTop}
							data-testid="celebration-photo-grid-top-side-image-top"
						>
							<Img
								src={vendorsWithImages[1].image as string}
								alt={vendorsWithImages[1].vendor.name}
								className={Styles.image}
								smartCrop
								data-testid="celebration-photo-grid-image-1"
							/>
						</div>
					)}
					{vendorsWithImages[2] && (
						<div
							className={Styles.topSideImageBottom}
							data-testid="celebration-photo-grid-top-side-image-bottom"
						>
							<Img
								src={vendorsWithImages[2].image as string}
								alt={vendorsWithImages[2].vendor.name}
								className={Styles.image}
								smartCrop
								data-testid="celebration-photo-grid-image-2"
							/>
						</div>
					)}
				</div>
			</div>
			<div
				className={Styles.bottomRowFive}
				data-testid="celebration-photo-grid-bottom-row"
			>
				{vendorsWithImages[3] && (
					<div
						className={Styles.bottomImageLeftFive}
						data-testid="celebration-photo-grid-bottom-image-left"
					>
						<Img
							src={vendorsWithImages[3].image as string}
							alt={vendorsWithImages[3].vendor.name}
							className={Styles.image}
							smartCrop
							data-testid="celebration-photo-grid-image-3"
						/>
					</div>
				)}
				{vendorsWithImages[4] && (
					<div
						className={Styles.bottomImageRightFive}
						data-testid="celebration-photo-grid-bottom-image-right"
					>
						<Img
							src={vendorsWithImages[4].image as string}
							alt={vendorsWithImages[4].vendor.name}
							className={Styles.image}
							smartCrop
							data-testid="celebration-photo-grid-image-4"
						/>
					</div>
				)}
			</div>
		</div>
	);
};
